<template>
  <div class="spinner-loader">
    <img src="../../../assets/img/loader/GIF1/100-100-V1.gif" />
  </div>
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// src/components/kneexpert/layouts/Loader.vue